import React from 'react';
import * as icons from './Icon-list';
interface IconProps {
  ariaLabel?: undefined | string;
  name: boolean | string;
  size?:
    | 'ads-font-size-01' // 12px
    | 'ads-font-size-02' // 14px
    | 'ads-font-size-03' // 16px
    | 'ads-font-size-04' // 18px
    | 'ads-font-size-05' // 20px
    | 'ads-font-size-06' // 24px
    | 'ads-font-size-07' // 28px
    | 'ads-font-size-08' // 32px
    | 'ads-font-size-09' // 36px
    | 'ads-font-size-10' // 42px
    | 'ads-font-size-11' // 48px
    | 'ads-font-size-12' // 54px
    | 'ads-font-size-13' // 60px
    | 'ads-font-size-14' // 68px
    | 'ads-font-size-15' // 76px
    | 'ads-font-size-16' // 84px
    | 'ads-font-size-17'; // 92px

  color?:
    | 'ads-color-icon-01' // blue
    | 'ads-color-icon-02' // gray
    | 'ads-color-disabled' // light gray
    | 'ads-color-danger' // red
    | 'ads-color-inverse' // white
    | 'ads-color-savings' // red
    | 'ads-color-support-error' // red
    | 'ads-color-support-success' // green
    | 'ads-color-support-warning' // yellow
    | 'ads-color-support-informational'; // blue
}

export const Icon: React.FC<IconProps> = ({
  ariaLabel,
  name,
  color = 'ads-color-icon-01',
  size = 'ads-font-size-06'
}) => {
  return (
    <span
      className="ads-icon"
      data-testid="ads-icon"
      style={{ display: 'flex' }}
      aria-label={ariaLabel}
    >
      {name === 'account' && icons.account(color, size)}
      {name === 'add' && icons.add(color, size)}
      {name === 'addCircleFilled' && icons.addCircleFilled(color, size)}
      {name === 'addCircleUnfilled' && icons.addCircleUnfilled(color, size)}
      {name === 'americanExpress' && icons.americanExpress()}
      {name === 'apple' && icons.apple(color, size)}
      {name === 'applePay' && icons.applePay()}
      {name === 'arrowDownLg' && icons.arrowDownLg(color, size)}
      {name === 'arrowDownSm' && icons.arrowDownSm(color, size)}
      {name === 'arrowLeftLg' && icons.arrowLeftLg(color, size)}
      {name === 'arrowLeftSm' && icons.arrowLeftSm(color, size)}
      {name === 'arrowNext' && icons.arrowNext(color, size)}
      {name === 'arrowPrevious' && icons.arrowPrevious(color, size)}
      {name === 'arrowRightLg' && icons.arrowRightLg(color, size)}
      {name === 'arrowRightSm' && icons.arrowRightSm(color, size)}
      {name === 'arrowUpLg' && icons.arrowUpLg(color, size)}
      {name === 'arrowUpSm' && icons.arrowUpSm(color, size)}
      {name === 'atm' && icons.atm(color, size)}
      {name === 'autoFill' && icons.autoFill(color, size)}
      {name === 'bakery' && icons.bakery(color, size)}
      {name === 'barcode' && icons.barcode(color, size)}
      {name === 'beer' && icons.beer(color, size)}
      {name === 'calendar' && icons.calendar(color, size)}
      {name === 'camera' && icons.camera(color, size)}
      {name === 'cameraFlip' && icons.cameraFlip(color, size)}
      {name === 'card' && icons.card()}
      {name === 'carWash' && icons.carWash(color, size)}
      {name === 'case' && icons.caseIcon(color, size)}
      {name === 'change' && icons.change(color, size)}
      {name === 'checkmarkLg' && icons.checkmarkLg(color, size)}
      {name === 'checkmarkSm' && icons.checkmarkSm(color, size)}
      {name === 'checkmarkSolid' && icons.checkmarkSolid(color, size)}
      {name === 'closeLg' && icons.closeLg(color, size)}
      {name === 'closeSm' && icons.closeSm(color, size)}
      {name === 'collapseLg' && icons.collapseLg(color, size)}
      {name === 'coupons' && icons.coupons(color, size)}
      {name === 'creditCard' && icons.creditCard(color, size)}
      {name === 'curbside' && icons.curbside(color, size)}
      {name === 'currentLocation' && icons.currentLocation(color, size)}
      {name === 'debug' && icons.debug(color, size)}
      {name === 'delete' && icons.deleteIcon(color, size)}
      {name === 'deli' && icons.deli(color, size)}
      {name === 'delivery' && icons.delivery(color, size)}
      {name === 'diners' && icons.diners()}
      {name === 'direction' && icons.direction(color, size)}
      {name === 'discover' && icons.discover()}
      {name === 'ebt' && icons.ebt()}
      {name === 'ebtCard' && icons.ebtCard(color, size)}
      {name === 'edit' && icons.edit(color, size)}
      {name === 'editTag' && icons.editTag(color, size)}
      {name === 'enlarge' && icons.enlarge(color, size)}
      {name === 'errorSolid' && icons.errorSolid(color, size)}
      {name === 'expand' && icons.expand(color, size)}
      {name === 'expressPickup' && icons.expressPickup(color, size)}
      {name === 'ev' && icons.ev(color, size)}
      {name === 'facebook' && icons.facebook(color, size)}
      {name === 'familyCare' && icons.familyCare(color, size)}
      {name === 'favoriteFilled' && icons.favoriteFilled(color, size)}
      {name === 'favoriteUnfilled' && icons.favoriteUnfilled(color, size)}
      {name === 'filter' && icons.filter(color, size)}
      {name === 'findAStore' && icons.findAStore(color, size)}
      {name === 'food' && icons.food(color, size)}
      {name === 'forklift' && icons.forklift(color, size)}
      {name === 'gas' && icons.gas(color, size)}
      {name === 'giftCards' && icons.giftCards(color, size)}
      {name === 'googlePay' && icons.googlePay()}
      {name === 'handTruck' && icons.handTruck(color, size)}
      {name === 'healing' && icons.healing(color, size)}
      {name === 'helpOutline' && icons.helpOutline(color, size)}
      {name === '24hrs' && icons.hrs(color, size)}
      {name === 'ice' && icons.ice(color, size)}
      {name === 'informationOutline' && icons.informationOutline(color, size)}
      {name === 'informationSolid' && icons.informationSolid(color, size)}
      {name === 'instagram' && icons.instagram(color, size)}
      {name === 'kerosene' && icons.kerosene(color, size)}
      {name === 'listAdd' && icons.listAdd(color, size)}
      {name === 'listDone' && icons.listDone(color, size)}
      {name === 'listEdit' && icons.listEdit(color, size)}
      {name === 'listRemove' && icons.listRemove(color, size)}
      {name === 'listResort' && icons.listResort(color, size)}
      {name === 'location' && icons.location(color, size)}
      {name === 'lotto' && icons.lotto(color, size)}
      {name === 'mastercard' && icons.mastercard()}
      {name === 'meijerCreditCard' && icons.meijerCreditCard()}
      {name === 'meijerM' && icons.meijerM(color, size)}
      {name === 'meijerMastercard' && icons.meijerMastercard()}
      {name === 'messages' && icons.messages(color, size)}
      {name === 'menu' && icons.menu(color, size)}
      {name === 'mFuel' && icons.mFuel(color, size)}
      {name === 'minimize' && icons.minimize(color, size)}
      {name === 'moreHorizontal' && icons.moreHorizontal(color, size)}
      {name === 'moreHorizontalSm' && icons.moreHorizontalSm(color, size)}
      {name === 'moreVertical' && icons.moreVertical(color, size)}
      {name === 'move' && icons.move(color, size)}
      {name === 'offer' && icons.offer(color, size)}
      {name === 'optical' && icons.optical(color, size)}
      {name === 'orders' && icons.orders(color, size)}
      {name === 'organic' && icons.organic(color, size)}
      {name === 'passwordHide' && icons.passwordHide(color, size)}
      {name === 'passwordReveal' && icons.passwordReveal(color, size)}
      {name === 'pastPurchase' && icons.pastPurchase(color, size)}
      {name === 'pdf' && icons.pdf(color, size)}
      {name === 'personalized' && icons.personalized(color, size)}
      {name === 'phone' && icons.phone(color, size)}
      {name === 'photo' && icons.photo(color, size)}
      {name === 'pickup' && icons.pickup(color, size)}
      {name === 'pinterest' && icons.pinterest(color, size)}
      {name === 'pill' && icons.pill(color, size)}
      {name === 'pizza' && icons.pizza(color, size)}
      {name === 'plu' && icons.plu(color, size)}
      {name === 'prescribers' && icons.prescribers(color, size)}
      {name === 'prescriptions' && icons.prescriptions(color, size)}
      {name === 'print' && icons.print(color, size)}
      {name === 'propane' && icons.propane(color, size)}
      {name === 'punchout' && icons.punchout(color, size)}
      {name === 'receipt' && icons.receipt(color, size)}
      {name === 'refillByScan' && icons.refillByScan(color, size)}
      {name === 'refresh' && icons.refresh(color, size)}
      {name === 'reminder' && icons.reminder(color, size)}
      {name === 'remove' && icons.remove(color, size)}
      {name === 'restroom' && icons.restroom(color, size)}
      {name === 'return' && icons.returnIcon(color, size)}
      {name === 'rewards' && icons.rewards(color, size)}
      {name === 'savings' && icons.savings(color, size)}
      {name === 'search' && icons.search(color, size)}
      {name === 'settings' && icons.settings(color, size)}
      {name === 'share' && icons.share(color, size)}
      {name === 'signIn' && icons.signIn(color, size)}
      {name === 'signOut' && icons.signOut(color, size)}
      {name === 'smallStarFilled' && icons.smallStarFilled(color, size)}
      {name === 'smallStarHalf' && icons.smallStarHalf(color, size)}
      {name === 'smallStarUnfilled' && icons.smallStarUnfilled(color, size)}
      {name === 'starFilled' && icons.starFilled(color, size)}
      {name === 'starHalf' && icons.starHalf(color, size)}
      {name === 'starUnfilled' && icons.starUnfilled(color, size)}
      {name === 'shoppingBag' && icons.shoppingBag(color, size)}
      {name === 'shoppingCart' && icons.shoppingCart(color, size)}
      {name === 'specialOffers' && icons.specialOffers(color, size)}
      {name === 'shopAndScan' && icons.shopAndScan(color, size)}
      {name === 'subtractCircleFilled' &&
        icons.subtractCircleFilled(color, size)}
      {name === 'subtractCircleUnfilled' &&
        icons.subtractCircleUnfilled(color, size)}
      {name === 'subtractSm' && icons.subtractSm(color, size)}
      {name === 'targeted' && icons.targeted(color, size)}
      {name === 'tobacco' && icons.tobacco(color, size)}
      {name === 'thumbprint' && icons.thumbprint(color, size)}
      {name === 'tipsRatings' && icons.tipsRatings(color, size)}
      {name === 'transferPrescriptions' &&
        icons.transferPrescriptions(color, size)}
      {name === 'twitter' && icons.twitter(color, size)}
      {name === 'updateInsurance' && icons.updateInsurance(color, size)}
      {name === 'warningSolid' && icons.warningSolid(size)}
      {name === 'weeklyAd' && icons.weeklyAd(color, size)}
      {name === 'wex' && icons.wex(color, size)}
      {name === 'viewGrid' && icons.viewGrid(color, size)}
      {name === 'vehicleCoupe' && icons.vehicleCoupe(color, size)}
      {name === 'vehicleMinivan' && icons.vehicleMinivan(color, size)}
      {name === 'vehicleMotorcycle' && icons.vehicleMotorcycle(color, size)}
      {name === 'vehicleSUV' && icons.vehicleSUV(color, size)}
      {name === 'vehicleSedan' && icons.vehicleSedan(color, size)}
      {name === 'vehiclePickupTruck' && icons.vehiclePickupTruck(color, size)}
      {name === 'vehicleHatchback' && icons.vehicleHatchback(color, size)}
      {name === 'viewList' && icons.viewList(color, size)}
      {name === 'visa' && icons.visa()}
      {name === 'yourStore' && icons.yourStore(color, size)}
      {name === 'youtube' && icons.youtube(color, size)}
    </span>
  );
};
